export const PHONE_CODES: number[] = [11, 12, 13, 14, 15, 16, 17, 18, 19, 21, 22, 24, 27, 28, 31, 32, 33, 34, 35, 37, 38, 41, 42, 43, 44, 45, 46, 47, 48, 49, 51, 53, 54, 55, 61, 62, 63, 64, 65, 66, 67, 68, 69, 71, 73, 74, 75, 77, 79, 81, 82, 83, 84, 85, 86, 87, 88, 89, 91, 92, 93, 94, 95, 96, 97, 98, 99];
export const STATE_COLORS: string[] = [
    "#0082ff", "#0082ff", "#0082ff", "#0082ff", "#0082ff", "#0082ff", "#0082ff", "#0082ff", "#0082ff",
    "#00ff12", "#00ff12", "#00ff12", "#b00000", "#b00000",
    "#ffb300", "#ffb300", "#ffb300", "#ffb300", "#ffb300", "#ffb300", "#ffb300",
    "#8f0000", "#8f0000", "#8f0000", "#8f0000", "#8f0000", "#8f0000", "#72b000", "#72b000", "#72b000",
    "#fff500", "#fff500", "#fff500", "#fff500",
    "#fff9bf", "#b09b00", "#55e500", "#b09b00", "#FF5533", "#FF5533", "#77004a", "#d55000", "#00d589",
    "#ffe500", "#ffe500", "#ffe500", "#ffe500", "#ffe500", "#00fffb",
    "#059400", "#ff6400", "#00a8ff", "#a10069", "#a19600", "#e66512", "#059400", "#a19600", "#e66512",
    "#b33006", "#008f24", "#b33006", "#b33006", "#00d589", "#008f24", "#008f24", "#00a8ff", "#00a8ff"
];

export enum BRAZIL_STATE_NAMES {
    ACRE = "Acre",
    ALAGOAS = "Alagoas",
    AMAZONAS = "Amazonas",
    AMAPA = "Amapá",
    BAHIA = "Bahia",
    CEARA = "Ceará",
    ESPIRITO_SANTO = "Espírito Santo",
    GOIAS = "Goiás",
    MARANHAO = "Maranhão",
    MINAS_GERAIS = "Minas Gerais",
    MATO_GROSSO_DO_SUL = "Mato Grosso do Sul",
    MATO_GROSSO = "Mato Grosso",
    PARA = "Pará",
    PARAIBA = "Paraíba",
    PERNAMBUCO = "Pernambuco",
    PIAUI = "Piauí",
    PARANA = "Paraná",
    RIO_DE_JANEIRO = "Rio de Janeiro",
    RIO_GRANDE_DO_NORTE = "Rio Grande do Norte",
    RONDONIA = "Rondônia",
    RORAIMA = "Roraima",
    RIO_GRANDE_DO_SUL = "Rio Grande do Sul",
    SANTA_CATARINA = "Santa Catarina",
    SERGIPE = "Sergipe",
    SAO_PAULO = "São Paulo",
    TOCANTINS = "Tocantins",
    DISTRITO_FEDERAL = "Distrito Federal",
}

export const BRAZIL_STATES = [
    BRAZIL_STATE_NAMES.ACRE,
    BRAZIL_STATE_NAMES.ALAGOAS,
    BRAZIL_STATE_NAMES.AMAZONAS,
    BRAZIL_STATE_NAMES.AMAPA,
    BRAZIL_STATE_NAMES.BAHIA,
    BRAZIL_STATE_NAMES.CEARA,
    BRAZIL_STATE_NAMES.ESPIRITO_SANTO,
    BRAZIL_STATE_NAMES.GOIAS,
    BRAZIL_STATE_NAMES.MARANHAO,
    BRAZIL_STATE_NAMES.MINAS_GERAIS,
    BRAZIL_STATE_NAMES.MATO_GROSSO_DO_SUL,
    BRAZIL_STATE_NAMES.MATO_GROSSO,
    BRAZIL_STATE_NAMES.PARA,
    BRAZIL_STATE_NAMES.PARAIBA,
    BRAZIL_STATE_NAMES.PERNAMBUCO,
    BRAZIL_STATE_NAMES.PIAUI,
    BRAZIL_STATE_NAMES.PARANA,
    BRAZIL_STATE_NAMES.RIO_DE_JANEIRO,
    BRAZIL_STATE_NAMES.RIO_GRANDE_DO_NORTE,
    BRAZIL_STATE_NAMES.RONDONIA,
    BRAZIL_STATE_NAMES.RORAIMA,
    BRAZIL_STATE_NAMES.RIO_GRANDE_DO_SUL,
    BRAZIL_STATE_NAMES.SANTA_CATARINA,
    BRAZIL_STATE_NAMES.SERGIPE,
    BRAZIL_STATE_NAMES.SAO_PAULO,
    BRAZIL_STATE_NAMES.TOCANTINS,
    BRAZIL_STATE_NAMES.DISTRITO_FEDERAL,
]